export interface Contact {
    id: number,
    timestamp: Date,
    newuserId?: number
    custId?: number,
    prefix?: string,
    firstName?: string,
    middleName?: string,
    lastName?: string,
    nickName?: string,
    jobTitle?: string,
    role?: ContactRoles,
    email?: string,
    attn?: string,
    address1?: string,
    address2?: string,
    city?: string,
    stateprov?: string,
    zipcode?: string,
    country?: string,
    phone1?: string,
    phone1Type?: PhoneTypes,
    phone2?: string,
    phone2Type?: PhoneTypes,
    phone3?: string,
    phone3Type?: PhoneTypes,
    freeTrip?: string,
    fmsc?: string,
    leadSource?: string,
    subscription?: ContactSubscription,
    netSuiteNum?: number,
    name?: string,
    internalId?: number,
    externalId?: number,
    category?: string,
    inactive: number,
    imported?: number

}


export enum PhoneTypes {
    NotSet = 0,
    Mobile = 1,
    Home = 2,
    Office = 3,
    Other = 4
  }

  export type ContactSubscription = "Confirmed Opt-Out" | "Confirmed Opt-In" | "Soft Opt-In" | "Soft Opt-Out" | "" 
  export type ContactRoles = "Primary Contact" | "Alternate Contact" | "Past contact" | "Consultant" | "Decision Maker" | "Financial contact" | "Senior Leadership" | "Other" | "Potential Donor" | "Active Donor" | "Inactive Donor"